module.exports = __webpack_public_path__ + "static/media/final-SEEKPI.70bc1bbd.png";